import HomeIcon from '@mui/icons-material/Home';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ManageAccounts from '@mui/icons-material/ManageAccounts';
import ListAltIcon from '@mui/icons-material/ListAlt';
import BinderIcon from '@mui/icons-material/MenuBook';
import MyServiceProsIcon from '@mui/icons-material/EngineeringOutlined';
// routes
import React from 'react';
import { PATH_DASHBOARD } from '../../routes/paths';
// components

// ----------------------------------------------------------------------

const ICONS = {
  dashboard: <DashboardIcon />,
  home: <HomeIcon />,
  myHome: <HomeWorkIcon />,
  admin: <ManageAccounts />,
  task: <ListAltIcon />,
  binder: <BinderIcon />,
  myServicePros: <MyServiceProsIcon />
};

// Card 208. This was 18 flat entries under one subheader, grown an item at a
// time. Seven of them — every category below — are the SAME page, told apart
// only by ?category=, so they read as seven destinations while being one; that
// alone was 39% of the menu. Grouping uses the `children:` array that admin
// already used, so this is config, not a new component.
//
// Titles were a mix of lowercase and Title Case; everything is Title Case now.
// Grouping changes navigation only — routes/index.js and paths.js are untouched
// and every existing URL still works.
const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      {
        title: 'Dashboard',
        path: PATH_DASHBOARD.general.app,
        icon: ICONS.dashboard
      },
      {
        title: 'Residence',
        path: PATH_DASHBOARD.general.residence,
        icon: ICONS.home
      },
      {
        // Defaults to expanded: these categories are the primary way a
        // homeowner reaches their belongings, and burying the whole inventory
        // behind a click is the one real risk in this reorganisation. The
        // group's own path keeps it open on item detail pages too.
        title: 'My Home',
        path: PATH_DASHBOARD.general.homeItems,
        icon: ICONS.myHome,
        defaultOpen: true,
        children: [
          { title: 'Exterior', path: '/dashboard/home-items?category=exterior' },
          { title: 'Interior', path: '/dashboard/home-items?category=interior' },
          { title: 'Appliances', path: '/dashboard/home-items?category=appliance' },
          { title: 'Utilities', path: '/dashboard/home-items?category=utility' },
          { title: 'Furniture', path: '/dashboard/home-items?category=furniture' },
          { title: 'Electronics', path: '/dashboard/home-items?category=electronic' },
          { title: 'Lawn & Leisure', path: '/dashboard/home-items?category=lawnAndLeisure' }
        ]
      },
      {
        title: 'Upkeep',
        icon: ICONS.task,
        children: [
          { title: 'Tasks', path: PATH_DASHBOARD.general.tasks },
          { title: 'Services', path: PATH_DASHBOARD.general.services },
          { title: 'Warranty', path: PATH_DASHBOARD.general.warranty },
          { title: 'Budget', path: PATH_DASHBOARD.general.budget },
          { title: 'Invoices', path: PATH_DASHBOARD.general.invoices }
        ]
      },
      {
        title: 'Records',
        icon: ICONS.binder,
        children: [
          { title: 'Home Binder', path: PATH_DASHBOARD.general.binder },
          { title: 'Home Health Report', path: PATH_DASHBOARD.general.homeHealthReport }
        ]
      },
      {
        title: 'People',
        icon: ICONS.myServicePros,
        children: [
          { title: 'My Service Pros', path: PATH_DASHBOARD.general.myServicePros },
          { title: 'Contacts', path: PATH_DASHBOARD.general.contacts }
        ]
      },
      {
        title: 'Admin',
        path: PATH_DASHBOARD.admin.root,
        icon: ICONS.admin,
        children: [
          { title: 'user role', path: PATH_DASHBOARD.admin.role },
          { title: 'master Brands', path: PATH_DASHBOARD.admin.brands },
          { title: 'Items', path: PATH_DASHBOARD.admin.items },
          { title: 'Home Care fulfillment', path: PATH_DASHBOARD.admin.careFulfillment },
          { title: 'Company claims', path: PATH_DASHBOARD.admin.companyClaims },
          { title: 'Footprint funnel', path: PATH_DASHBOARD.admin.proFunnel },
          { title: 'master industry type', path: PATH_DASHBOARD.admin.industryType },
          { title: 'Master Residence', path: PATH_DASHBOARD.admin.homeHacks },
          { title: 'Send Email Notification', path: PATH_DASHBOARD.admin.emailNotication },
          { title: 'Broadcasts', path: PATH_DASHBOARD.admin.broadcasts },
          { title: 'Create Blog', path: PATH_DASHBOARD.admin.blog },
          { title: 'Create News', path: PATH_DASHBOARD.admin.news },
          { title: 'Create Coming Soon', path: PATH_DASHBOARD.admin.comingSoon }
        ]
      }
    ]
  }
];

export default sidebarConfig;
